<div class="grid-container margin-top">
  <form [formGroup]="form">
    <div class="grid-x">
      <div class="cell large-3 medium-3 small-4 bold text-align-right padding-right-small" [ngStyle]="{ 'display': (currentStep == permitSteps.SelectWell) ? 'block' : 'none' }">
        Select an API #: <span [ngClass]="{ 'red' : form?.get('api')?.invalid }">*</span>
      </div>
      <div class="cell large-8 medium-8 small-7" [ngStyle]="{ 'display': (currentStep == permitSteps.SelectWell) ? 'inherit' : 'none' }">
        <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="apiNumbers$ | async" [selectionColumnDef]="selectionColumnDef" (selectionChanged)="apiSelected($event)" aria-label="Regenerate Permit"></ag-grid-angular>
      </div>
      <div class="cell large-1 medium-1 small-1 text-align-left padding-left" [ngStyle]="{ 'display': (currentStep == permitSteps.SelectWell) ? 'inherit' : 'none' }">
        <help-text [helpText]="wheresMyAPI"></help-text>
      </div>
      @if (currentStep == permitSteps.SelectPermits) {
        <div class="cell large-3 medium-3 small-4 bold text-align-right padding-right-small">
          Select Permit(s): <span [ngClass]="{ 'red' : form?.get('permits')?.invalid }">*</span>
        </div>
        <div class="cell large-8 medium-8 small-7">
          <ag-grid-angular class="data-grid " [gridOptions]="permitGridOptions" [rowData]="permit$ | async" (selectionChanged)="permitSelected($event)" aria-label="Regenerate Permit"></ag-grid-angular>
        </div>
        <div class="cell large-1 medium-1 small-1">
          <help-text [helpText]="wheresMyPermit"></help-text>
        </div>
        <schematics-preview [permit]="permitToPreviewSchematic" (permitChanged)="onSchematicUpdated($event)"></schematics-preview>
      }
      @if (currentStep == permitSteps.ConfirmDocuments) {
        <div class="cell large-12 medium-12 small-12 text-align-center">
          The regenerated documents will be shown below.  Download and verify that the permit(s) are accurate, and select those you wish to upload.
        </div>
        <div class="cell large-12 medium-12 small-12 red italic text-align-center">
          Note: Documents uploaded at the time the original application was submitted may not be attached in the same page order as the original permit.
        </div>
        <div class="cell large-3 medium-3 small-4 bold align-right padding-right-small">
          Select Permits to Upload: <span [ngClass]="{ 'red' : form?.get('documents')?.invalid }">*</span>
        </div>
        <div class="cell large-9 medium-9 small-8">
          <ag-grid-angular class="data-grid " [gridOptions]="regeneratedGridOptions" [rowData]="generator$ | async" (selectionChanged)="documentsSelected($event)" aria-label="Regenerate Permit"></ag-grid-angular>
        </div>
      }
      @if (currentStep == permitSteps.SaveDocuments) {
        @if (showResults.value) {
          <div class="cell large-12 medium-12 small-12">
            <div class="grid-x grid-margin-x">
              <div class="cell large-3 medium-3 small-4">
                <span class="bold">Permit #</span>
              </div>
              <div class="cell large-9 medium-9 small-8">
                <span class="bold">Upload Status</span>
              </div>
            </div>
          </div>
          @for (doc of uploadingDocuments; track doc) {
            <div class="cell large-12 medium-12 small-12">
              <upload-status [document]="doc"></upload-status>
            </div>
          }
        }
      }
      <div class="cell large-12 medium-12 small-12">
        <div class="sections-container">
          <div class="flex progress-wrapper">
            <div class="progress-container text-center flex-item-center">
              <h3 class="white">Progress:</h3>
              <span class="section-number-of white">({{currentStep}} of 4)</span>
            </div>
            <div class="indicators-wrapper flex-item-center">
              <section class="indicator-container">
                @for (step of steps; track step; let i = $index) {
                  <div class="sections-indicators" attr.id="indicator{{i + 1}}" attr.aria-label="Step {{i + 1}}">
                    <section-indicator [number]="step.id" [text]="step.text" [isActive]="currentStep == step.idNumeric"></section-indicator>
                  </div>
                }
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<a href="" style="display:none" target="_blank" #downloadLink rel="noopener noreferrer"></a>